import { Link } from 'react-router-dom';
import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ghadminapi from '../api/ghadminapi';
import loginapi from '../api/login';
import { FaPlusCircle } from "react-icons/fa";

import { APISERVERURL } from '../APIServerURL';
import GSTBillComponent from '../components/AdminGSTBillComponent';
import RetailBillComponent from '../components/AdminRetailBillComponent'
import AdminCashMemoComponent from '../components/AdminCashMemoComponent'


function AdminViewAGSTBill({accessToken,setAccessToken, setRefreshFailed}) {
  const navigate = useNavigate();  
  const { form_id} = useParams();
  const [formListLoaded,setFormListLoaded]=useState(false);
  const [registrationForm,setRegistrationForm]=useState(null);
  const [isAppLoaded,setIsAppLoaded]=useState(true);


    
  const saveForm=async ()=>{
   
  }


  const loadForm=async ()=>{
    setFormListLoaded(false);
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await ghadminapi.post('/getRegistrationForm',{form_id},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setRegistrationForm(response.data.registrationForm);
      setFormListLoaded(true);
      //alert(JSON.stringify(response.data));
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await ghadminapi.post('/getRegistrationForm',{form_id},{headers:{'Authorization':`Bearer ${nat}`}});   
                      setRegistrationForm(response.data.registrationForm);
                      setFormListLoaded(true);
                      //alert(JSON.stringify(response.data));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
            setFormListLoaded(true);
          }
  }

  function downloadFile(fname)
  {
    fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
      response.blob().then((blob) => {         
          // Creating new object of PDF file
          const fileURL =
              window.URL.createObjectURL(blob);
               
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = fname;
          alink.click();
          setIsAppLoaded(true);
      });
    });
  }
const handleDownload=async (e)=>{
    setIsAppLoaded(false);
  e.preventDefault();
  try{
    //alert(img+" "+postId);
    //post request to deletePhoto wit {id,fileName}
    setIsAppLoaded(false);
    const response= await ghadminapi.post('/downloadRegistrationForm',{form_id:registrationForm._id,bill_number:registrationForm.bill_number},{headers:{'Authorization':`Bearer ${accessToken}`}});    
    alert(response.data);
    downloadFile(response.data);
  }
  catch(err)
  {
    if( err.response.status===403)
      {
        navigate(`/accessdenied`); 
      }
    try{
      const config = { withCredentials: true };
      const x=await loginapi.get('/getAccessToken',config);
      //alert(JSON.stringify(x['data']['accessToken']));
      
      const nat=x['data']['accessToken'];
      setAccessToken(nat);
      //console.log(`ne at ${nat}`);
      //console.log(`Second at:${accessToken}`);
      //alert('ok');
      try{       
        const response= await ghadminapi.post('/downloadRegistrationForm',{form_id:registrationForm._id,bill_number:registrationForm.bill_number},{headers:{'Authorization':`Bearer ${nat}`}});    
        alert(JSON.stringify(response.data));
        downloadFile(response.data);
       }
       catch(err)
       {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        alert('unusual error newposts.js');
        setIsAppLoaded(true);
        //alert(JSON.stringify(err));
        //navigate('/');
       }
    }
    catch(err)
    {
      alert(JSON.stringify(err));
      setIsAppLoaded(true);
      //setError(JSON.stringify(err));
      //navigate('/');
    }

  }
}

const handleSubmit=async ()=>{
  
  try{       
    //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
    const response=await ghadminapi.post('/allowEditForm',{registrationForm},{headers:{'Authorization':`Bearer ${accessToken}`}});  
    setRegistrationForm(response.data.registrationForm);navigate(-1); // Goes back to the previous page
    //setFormListLoaded(true);
    //alert(JSON.stringify(response.data));
    }
    catch(err)
    {
      if( err.response.status===403)
        {
          navigate(`/accessdenied`); 
        }
      try{
        const config = { withCredentials: true };
        const x=await loginapi.get('/getAccessToken',config);            
        const nat=x['data']['accessToken'];
        const lt=x['data']['loginType'];
        //alert(nat);
        setAccessToken(nat);
        setRefreshFailed(false);  
                
       
          if(lt.toLowerCase()==="admin")
            {
                  try{       
                    //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                    const response=await ghadminapi.post('/allowEditForm',{registrationForm},{headers:{'Authorization':`Bearer ${nat}`}});   
                    setRegistrationForm(response.data.registrationForm);navigate(-1); // Goes back to the previous page
                    //setFormListLoaded(true);
                    //alert(JSON.stringify(response.data));
                }
                catch(err)
                {
                  if( err.response.status===403)
                    {
                      navigate(`/accessdenied`); 
                    }
                  //alert('refresh failed unusual'+JSON.stringify(err));
                  setAccessToken('');
                  setRefreshFailed(true);  
                }
              }
        }
        catch(err)
        {
          //alert('dd');
          setAccessToken(''); 
          setRefreshFailed(true);              
        }
    }         
     finally
        {
          //setIsAppLoaded(true);
          //alert('app loaded'+accessToken);
          //setFormListLoaded(true);
        }
}

const handleCancel=async (status)=>{
  
  try{       
    //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
    const response=await ghadminapi.post('/cancelbill',{registrationForm,status},{headers:{'Authorization':`Bearer ${accessToken}`}});  
    setRegistrationForm(response.data.registrationForm);navigate(-1); // Goes back to the previous page
    //setFormListLoaded(true);
    //alert(JSON.stringify(response.data));
    }
    catch(err)
    {
      if( err.response.status===403)
        {
          navigate(`/accessdenied`); 
        }
      try{
        const config = { withCredentials: true };
        const x=await loginapi.get('/getAccessToken',config);            
        const nat=x['data']['accessToken'];
        const lt=x['data']['loginType'];
        //alert(nat);
        setAccessToken(nat);
        setRefreshFailed(false);  
                
       
          if(lt.toLowerCase()==="admin")
            {
                  try{       
                    //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                    const response=await ghadminapi.post('/cancelbill',{registrationForm,status},{headers:{'Authorization':`Bearer ${nat}`}});   
                    setRegistrationForm(response.data.registrationForm);navigate(-1); // Goes back to the previous page
                    //setFormListLoaded(true);
                    //alert(JSON.stringify(response.data));
                }
                catch(err)
                {
                  if( err.response.status===403)
                    {
                      navigate(`/accessdenied`); 
                    }
                  //alert('refresh failed unusual'+JSON.stringify(err));
                  setAccessToken('');
                  setRefreshFailed(true);  
                }
              }
        }
        catch(err)
        {
          //alert('dd');
          setAccessToken(''); 
          setRefreshFailed(true);              
        }
    }         
     finally
        {
          //setIsAppLoaded(true);
          //alert('app loaded'+accessToken);
          //setFormListLoaded(true);
        }
}
  useEffect(()=>{
    loadForm();
  },[]);

  return (
    <main className="w-full">
     <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center">{formListLoaded && (<span>{registrationForm.type.toUpperCase()}</span>)} BILL DETAILS</h1>
            <p className='text-center text-xs text-transparent'>
            (The form is auto-saved.You can fill out the form now and submit it later.)
            </p>
          </div>         
        
          {formListLoaded && registrationForm.type.toUpperCase()==='GST' &&(
            <div className="w-full bg-gray-100 mt-2 py-1 flex flex-wrap gap-4 justify-center items-center min-h-[150px]">
              <GSTBillComponent
              registrationForm={registrationForm}
              setRegistrationForm={setRegistrationForm}
              saveForm={saveForm}
              handleSubmit={handleSubmit}
              handleDownload={handleDownload}
                   handleCancel={handleCancel}
              >

              </GSTBillComponent>
            </div>
          )}
          {formListLoaded && registrationForm.type.toUpperCase()==='RETAIL' &&(
            <div className="w-full bg-gray-100 mt-2 py-1 flex flex-wrap gap-4 justify-center items-center min-h-[150px]">
              <RetailBillComponent
              registrationForm={registrationForm}
              setRegistrationForm={setRegistrationForm}
              saveForm={saveForm}
              handleSubmit={handleSubmit}
              handleDownload={handleDownload}
                   handleCancel={handleCancel}
              >

              </RetailBillComponent>
            </div>
          )}
          {formListLoaded && registrationForm.type.toUpperCase()==='CASHMEMO' &&(
            <div className="w-full bg-gray-100 mt-2 py-1 flex flex-wrap gap-4 justify-center items-center min-h-[150px]">
              <AdminCashMemoComponent
              registrationForm={registrationForm}
              setRegistrationForm={setRegistrationForm}
              saveForm={saveForm}
              handleSubmit={handleSubmit}
              handleDownload={handleDownload}
              handleCancel={handleCancel}
              >

              </AdminCashMemoComponent>
            </div>
          )}

          
     </div>
    {
   (!formListLoaded) && <div className="w-[98%] max-w-[1200px]">
    Please wait!
    </div>
    }
    </main>
  );
  }
  
  export default AdminViewAGSTBill